module.exports = __webpack_public_path__ + "static/media/Inter-BlackItalic.e78a230f.woff2";